exports = module.exports = require("../../../../../../releases/187ec55da5eb3d47902755ca8b43750fb9d7d6d1/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mwb-icon {\n  vertical-align: super;\n}\n\n.mwb-icon > svg {\n  vertical-align: unset;\n}\n\n.mwb-icon,\n.mwb-icon > svg {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  fill: currentColor;\n}\n\n.block-editor .interface-interface-skeleton__body {\n  max-width: 100vw;\n}", ""]);

// exports
